export default {"src":"/_next/static/media/vault-logo-mark_on-light.d21bede4.svg","height":72,"width":53,"blurWidth":0,"blurHeight":0};